// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/4ebfd9d278814438e893.bundle.js";
	if (chunkId === 3) return "static/js/ee52a1547bf32e80506f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"1c72f969d1dafa45b540","139":"66ee6d70b9b1d020ef0a","140":"2e83b2e1ad71dfed2750"}[chunkId] + ".chunk.js";
};